import Link from 'components/gruenland/atoms/link';
import Breadcrumb from 'components/gruenland/molecules/breadcrumb/Breadcrumb';
import usePath from 'helpers/hooks/usePath';
import { useMemo } from 'react';
import { Category } from 'types/entity/category';

interface Props {
  categoryId?: string;
  categories: Category[];
}

const Breadcrumbs: React.FC<Props> = ({ categoryId, categories }) => {
  const { path } = usePath();

  const ancestorCategories = useMemo(() => {
    if (!path) return [];

    const categoryIdChunks = path.split('?')[0].slice(1).split('/').filter(Boolean).slice(0, -1);

    return categoryIdChunks.map(
      (id) => (categories.find((category) => [category.categoryId, category.slug].includes(id)) ?? {}) as Category,
    );
  }, [path, categories]);

  const currentCategory = useMemo(() => {
    return (categories.find((category) => category.categoryId === categoryId) ?? {}) as Category;
  }, [categories, categoryId]);

  if (!categoryId) return <></>;

  return (
    <>
      <Breadcrumb>
        <Link link="/">Home</Link>
        {ancestorCategories.map((category) => (
          <Link key={category.categoryId} link={category._url}>
            {category.name}
          </Link>
        ))}
        {currentCategory && (
          <Link key={currentCategory.categoryId} link={currentCategory._url}>
            {currentCategory.name}
          </Link>
        )}
      </Breadcrumb>
    </>
  );
};

export default Breadcrumbs;
